module.exports = require('./globals.json');



//////////////////
// WEBPACK FOOTER
// /Users/charles/Projects/codemix/2016/flow-runtime/~/globals/index.js
// module id = 304
// module chunks = 0